import { atom } from 'jotai';

export enum AmountSelectionAlertState {
  AWAITING_LINK = 'AWAITING_LINK',
  SUCCESSFUL_LINK = 'SUCCESSFUL_LINK',
  NONE = 'NONE',
}

interface AmountSelectionInlineAlert {
  inlineAlertStatus: AmountSelectionAlertState;
}
export const AmountSelectionInlineAlertAtom = atom<AmountSelectionInlineAlert>({
  inlineAlertStatus: AmountSelectionAlertState.NONE,
});
